<script>
    import {mapState, mapActions, mapGetters} from 'vuex'


    import comAdmin from './com/admin.vue'
    import comLogout from './com/logout.vue'
    import comMessages from './com/messages.vue'
    import comEvents from './com/events.vue'
    import comUser from './com/user.vue'
    import comDate from './com/date.vue'
    import comVideo from './com/video.vue'
    import comWiki from './com/wiki.vue'

    export default {
        props: {},
        data() {
            return {
                newsType: 0
            }
        },
        methods: {
            getNewsType () {
                axios({
                    method: 'get',
                    url: '/tourclient//settings/index'
                }).then(({data}) => {
                    this.newsType = data.MasterAgentSettings.NewsType;
                }).catch(e => {

                });
            }
        },
        computed: {
        ...mapState('user', {
                auth: 'auth',
            }),
        },
        watch: {},
        mounted() {
            this.getNewsType()
        },
        components: {comAdmin, comLogout, comEvents, comUser, comDate, comVideo, comWiki, comMessages},
    }
</script>
<template>
    <div class="mag-header">
        <div class="wrap" v-if="auth">
            <div v-if="newsType==0" onclick="news_feed.show()" class="news_button">Новости</div>
            <com-date class="mag-header-item"></com-date>
            <com-messages class="mag-header-item"></com-messages>
            <com-events class="mag-header-item"></com-events>
            <com-user class="mag-header-item"></com-user>
            <com-admin class="mag-header-item"></com-admin>
            <com-wiki class="mag-header-item"></com-wiki>
            <com-video class="mag-header-item"></com-video>
            <com-logout class="mag-header-item"></com-logout>
        </div>
        <div class="wrap" v-if="!auth">
            <div class="mag-header__phone">
                <a href="tel:+74956020020">+7 (495) 6-020-020</a>
            </div>
            <div class="mag-header__logo">
                <a href="http://www.mag.travel">
                    <img src="./img/mag_logo.png" alt="Система MAG – система online бронирования различных туристических услуг">
                </a>
            </div>
            <div class="mag-header__other">
                <div class="mag-header__links">
                    <a href="https://www.youtube.com/channel/UCPCQakD1XsIQIAAwpsgThqQ" target="_blank">
                        <img src="./img/youtube.png" alt="">
                    </a>
                    <a href="https://www.facebook.com/magtravel2016/" target="_blank">
                        <img src="./img/facebook.png" alt="">
                    </a>
                </div>
                <div class="mag-header__links">
                    <a href="#/login" class="mag-header__link"><i class="mag-icon-nav-menu-locked"></i> вход</a>
                    <a href="#/registration" class="mag-header__link"><i class="mag-icon-nav-top-user"></i> регистрация</a>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss">
    .mag-header {
        background: #fff;
        border-bottom: 2px solid #eee;

        .news_button {
            position: absolute;
            left: 0;
            font-size: 14px;
            cursor: pointer;
            height: 40px;
            line-height: 40px;
        }

        &-item {
            height: 100%;
            border-right: 1px solid #eee;
            color: #a3a3a3;
        }
        &__poper-link{
            display: inline-block;
            width: 100%;
            color: #666;
            text-decoration: none;
            padding: 8px 0;
        }
        .wrap {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            height: 100%;
            position: relative;
        }
        .el-dropdown{
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
            padding: 0;
            margin: 0;
            border-radius: 0;
            border: none;
            background: none;
            width: 38px;
            position: relative;
            line-height: 36px;
            font-size: 20px;
            text-align: center;
            color: #a3a3a3;
        }
        i{
            outline: none;
        }
    }
    .login{
        .mag-header{
            position: relative;
            width: 100%;
            height: 100px;
            background: #fff url(./img/header_bg.png) no-repeat center top;
            padding-bottom: 16px;
            &:before {
                content: '';
                display: block;
                position: absolute;
                bottom: 0;
                left: 0;
                background: url(./img/head_bottom_border.png) no-repeat center;
                height: 9px;
                width: 100%;
            }
            &__phone {
                padding: 42px 0 0 62px;
                a{
                    font-size: 25px;
                    font-weight: 300;
                    float: left;
                    line-height: 0.8;
                    text-decoration: none;
                    color: #778ea8;
                }
            }
            &__logo{
                padding: 16px 0;
                text-align: center;
            }
            &__links{
                text-align: right;
                .mag-header__link{
                    background: #fff;
                    font-size: 16px;
                    height: 35px;
                    line-height: 33px;
                    padding: 0;
                    width: 152px;
                    text-align: center;
                    border: 1px solid #bbc6d3;
                    color: #778ea8;
                    text-decoration: none;
                    display: inline-block;
                    border-radius: 3px;
                    box-sizing: border-box;
                    margin: 8px 0 0 4px;
                }
            }
            .wrap {
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                >div {
                    width: 100%/3;
                }
            }

        }
    }
</style>
